<template>
  <a-collapse
    v-model:activeKey="activeKey"
    expand-icon-position="right"
    :bordered="false"
    class="review"
  >
    <a-collapse-panel>
      <div class="content">
        <div v-if="isPerformanceLeader">
          <div
            v-for="item in organizationalSkillsPerspectiveSelfReview"
            :key="item"
            class="item"
          >
            <div class="title">
              {{ $t(`okr.personalObjective.${item}`) }}
            </div>
            <div
              class="value"
              v-html="replaceStr2Html(organizationalSkillsSelfReview[item] || $t(`okr.nothing`))"
            />
          </div>
        </div>
        <div v-else>
          <div
            v-for="item in personalDevelopmentPerspectiveSelfReview"
            :key="item"
            class="item"
          >
            <div class="title">
              {{ $t(`okr.personalObjective.${item}`) }}
            </div>
            <div
              class="value"
              v-html="replaceStr2Html(personalDevelopmentSelfReview[item] || $t(`okr.nothing`))"
            />
          </div>
        </div>
      </div>
      <template #header>
        <a-space :style="{ marginLeft: '24px' }">
          <IconFont
            type="iconpingjia"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold' }">
            {{ title }}
          </span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import { computed, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  organizationalSkillsPerspectiveSelfReview,
  personalDevelopmentPerspectiveSelfReview
} from '@/constants/perspective'
import { replaceStr2Html } from '@/utils/line-break'
export default {
  props: {
    isPerformanceLeader: {
      type: Boolean,
      default: false
    },
    organizationalSkillsSelfReview: {
      type: Object,
      default: () => {}
    },
    personalDevelopmentSelfReview: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    const { t } = useI18n()
    const { isPerformanceLeader } = toRefs(props)
    const activeKey = ref(['performance-review'])
    const title = computed(() => {
      return (isPerformanceLeader.value ? t('okr.titles.leaderTitle') : t('okr.titles.normalTitle')) + ' ' + t('okr.list.performanceReview')
    })
    return {
      title,
      activeKey,
      organizationalSkillsPerspectiveSelfReview,
      personalDevelopmentPerspectiveSelfReview,
      replaceStr2Html
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.ant-collapse-borderless) {
  background-color: transparent !important;
}

:deep(.ant-collapse-header) {
  border-top: 1px solid #f0f0f0;
}

.review {
  background: #fff;
}

.item:not(:last-child) {
  margin-bottom: 24px;
}

.title {
  font-weight: bolder;
}
.value {
  padding-top: 12px;
}

.content {
  padding: 0 24px 12px 50px;
}
</style>
